
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class AtmosphericEntryEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const drawFlayer = (x: number, y: number, s: number) => {
             ctx.save();
             ctx.translate(x, y);
             ctx.rotate(Math.PI / 4);
             
             // Re-entry heat shield glow
             const grad = ctx.createRadialGradient(0, 0, 0, 0, 0, s * 2);
             grad.addColorStop(0, pc.color);
             grad.addColorStop(1, 'transparent');
             ctx.fillStyle = grad;
             ctx.globalAlpha *= 0.4;
             ctx.beginPath();
             ctx.arc(0, 0, s * 2, -Math.PI/2, Math.PI/2);
             ctx.fill();
             
             // Plasma streaks
             for (let i = 0; i < 5; i++) {
                 ctx.beginPath();
                 ctx.lineWidth = (2 + i) * scale;
                 ctx.moveTo(0, (i - 2) * 5 * scale);
                 ctx.lineTo(-s * 5 - i * 20, (i - 2) * 10 * scale);
                 ctx.stroke();
             }
             ctx.restore();
        };

        const draw = () => {
             const x = ((curTime * 1200) % (width * 4)) - width * 2;
             const y = ((curTime * 1200) % (height * 4)) - height * 2;
             drawFlayer(x, y, 40 * scale / (layerIndex + 1));
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
